/* VK PDP Add to Cart - TRULY FIXED VERSION */
(function() {
  'use strict';
  
  function init() {
    const isPDP = document.body.classList.contains('vk-template-product') || 
                  document.body.classList.contains('vk-page-product');
    
    if (!isPDP) return;
    
    const control = document.querySelector('[data-vk-pdp-control]');
    if (!control) return;
    
    const btn = control.querySelector('[data-vk-atc]');
    const stepper = control.querySelector('[data-vk-stepper]');
    const minusBtn = stepper?.querySelector('[data-vk-minus]');
    const plusBtn = stepper?.querySelector('[data-vk-plus]');
    const countEl = stepper?.querySelector('[data-vk-count]');
    const variantInput = control.querySelector('input[name="id"]');
    
    if (!btn || !stepper || !variantInput) return;
    
    let currentQty = 0;
    
    function updateUI() {
      if (currentQty === 0) {
        btn.style.display = '';
        btn.removeAttribute('hidden');
        stepper.style.display = 'none';
        stepper.setAttribute('hidden', '');
      } else {
        btn.style.display = 'none';
        btn.setAttribute('hidden', '');
        stepper.style.display = '';
        stepper.removeAttribute('hidden');
        if (countEl) countEl.textContent = currentQty;
      }
      
      // CHANGED: Minus enabled even at 1 (to allow going to 0)
      if (minusBtn) minusBtn.disabled = false;
    }
    
    // Add button
    btn.addEventListener('click', async function() {
      const vid = variantInput.value;
      if (!vid) return;
      
      btn.disabled = true;
      currentQty = 1;
      updateUI();
      
      try {
        const formData = new FormData();
        formData.append('id', vid);
        formData.append('quantity', '1');
        
        await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        document.dispatchEvent(new CustomEvent('vk:cart:updated'));
      } catch (error) {
        currentQty = 0;
        updateUI();
      } finally {
        btn.disabled = false;
      }
    });
    
    // Plus button
    if (plusBtn) {
      plusBtn.addEventListener('click', async function() {
        const vid = variantInput.value;
        if (!vid) return;
        
        plusBtn.disabled = true;
        currentQty++;
        updateUI();
        
        try {
          const formData = new FormData();
          formData.append('id', vid);
          formData.append('quantity', '1');
          
          await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          document.dispatchEvent(new CustomEvent('vk:cart:updated'));
        } catch (error) {
          currentQty--;
          updateUI();
        } finally {
          plusBtn.disabled = false;
          updateUI();
        }
      });
    }
    
    // Minus button - TRULY FIXED
    if (minusBtn) {
      minusBtn.addEventListener('click', async function() {
        // CHANGED: Allow clicking even at 1 to go to 0
        if (currentQty < 1) return;
        
        minusBtn.disabled = true;
        const nextQty = currentQty - 1;
        currentQty = nextQty;
        updateUI();
        
        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          const line = cart.items.find(item => String(item.variant_id) === String(variantInput.value));
          
          if (line) {
            const formData = new FormData();
            formData.append('id', line.key);
            formData.append('quantity', String(nextQty));
            
            await fetch('/cart/change.js', {
              method: 'POST',
              body: formData
            });
            
            document.dispatchEvent(new CustomEvent('vk:cart:updated'));
          }
        } catch (error) {
          currentQty++;
          updateUI();
        } finally {
          minusBtn.disabled = false;
          updateUI();
        }
      });
    }
    
    // Variant changes (6/12 buttons) - FIXED: Now toggles is-active class
    const variantButtons = document.querySelectorAll('[data-vk-variant-btn]');
    variantButtons.forEach(function(variantBtn) {
      variantBtn.addEventListener('click', function() {
        // Toggle is-active class on variant buttons within the same card/control
        const card = variantBtn.closest('.vk-card, article, [data-vk-pdp-control]');
        if (card) {
          const allBtns = card.querySelectorAll('[data-vk-variant-btn]');
          allBtns.forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
        }
        variantBtn.classList.add('is-active');
        variantBtn.setAttribute('aria-pressed', 'true');
        
        // Sync cart quantity for the newly selected variant
        setTimeout(function() {
          if (!variantInput?.value) return;
          
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              const line = cart.items.find(item => 
                String(item.variant_id) === String(variantInput.value)
              );
              
              currentQty = line ? Number(line.quantity) : 0;
              updateUI();
            })
            .catch(err => {
              currentQty = 0;
              updateUI();
            });
        }, 50);
      });
    });
    
    updateUI();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();